import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PayerForCenterRequest } from '../../services/verifyService/commands';

interface VerificationModuleState{
    DetailTab:number;
    CodeLookupModal:boolean;
    InsuranceDetailModal: boolean;
    SelectedPayer: PayerForCenterRequest;
    VerifyLookupModal: boolean;
    NoteAddModal:boolean;
    EscalatedNoteAddModal:boolean;
    EscalatedNoteResolutionModal:boolean;
    VobRequestNoteAddModal:boolean;
    VobRequestNoteResolutionModal:boolean;
    CallAddModal: boolean;
    WaystarModal: boolean;
    SelectedCall:string;
    CallViewModal:boolean;
    VerifyDocumentDialog:boolean;
    PatientRespNoteAddModal: boolean;
    PatientRespChangeNote:string;
    PatientRespChangeNoteCategory:string;
    DrgGroupMatching:boolean;
    OutPatientLCodeMatchingModal:boolean;
    HumanaReferralWarningDialog:boolean;
    BcbsT2GWarningDialog:boolean;
    ProcedureCodeSetMatchingModal:boolean;
    PreQuoteCreateDialog:boolean;
    PreQuoteEditDialog:boolean;
}

const initialState:VerificationModuleState={DetailTab:0, CodeLookupModal: false, InsuranceDetailModal: false, NoteAddModal:false,
     EscalatedNoteAddModal:false, EscalatedNoteResolutionModal:false, VobRequestNoteAddModal:false, VobRequestNoteResolutionModal:false, VerifyLookupModal:false, CallAddModal:false, SelectedPayer: new PayerForCenterRequest('',''), WaystarModal:false, SelectedCall:'',
     CallViewModal:false, VerifyDocumentDialog:false, PatientRespNoteAddModal:false, PatientRespChangeNote:'', PatientRespChangeNoteCategory:'',
     DrgGroupMatching:false, OutPatientLCodeMatchingModal:false, HumanaReferralWarningDialog:false, BcbsT2GWarningDialog:false, ProcedureCodeSetMatchingModal:false, PreQuoteCreateDialog:false, PreQuoteEditDialog:false}

export const VerificationModuleSlice = createSlice({
    name:'verificationModule',
    initialState,
    reducers:{
        toggleDetailTab:(state, action:PayloadAction<number>) => {
            state.DetailTab = action.payload;
        },
        toggleCodeLookup:(state) => {
            state.CodeLookupModal = !state.CodeLookupModal;
        },
        toggleInsuranceDetail:(state, action:PayloadAction<PayerForCenterRequest>) => {
            state.InsuranceDetailModal = !state.InsuranceDetailModal;
            state.SelectedPayer = action.payload;
        },
        toggleVerifyLookupModal:(state) => {
            state.VerifyLookupModal = !state.VerifyLookupModal;
        },
        toggleNoteAddModal:(state) => {
            state.NoteAddModal = !state.NoteAddModal;
        },
        toggleEscalatedNoteAddModal:(state) => {
            state.EscalatedNoteAddModal = !state.EscalatedNoteAddModal;
        },
        toggleEscalatedNoteResolutionModal:(state) => {
            state.EscalatedNoteResolutionModal = !state.EscalatedNoteResolutionModal;
        },
        toggleVobRequestNoteAddModal:(state) => {
            state.VobRequestNoteAddModal = !state.VobRequestNoteAddModal;
        },
        toggleVobRequestNoteResolutionModal:(state) => {
            state.VobRequestNoteResolutionModal = !state.VobRequestNoteResolutionModal;
        },
        toggleCallAddModal:(state) => {
            state.CallAddModal = !state.CallAddModal;
        },
        toggleWaystarModal:(state, action:PayloadAction<PayerForCenterRequest>) => {
            state.SelectedPayer = action.payload;
            state.WaystarModal = !state.WaystarModal;
        },
        toggleCallViewModal:(state, action:PayloadAction<string>)=>{
            state.SelectedCall = action.payload;
            state.CallViewModal = !state.CallViewModal;
        },
        toggleVerifyDocumentDialog:(state) => {
            state.VerifyDocumentDialog = !state.VerifyDocumentDialog;
        },   
        togglePatientRespNoteAddModal:(state) => {
            state.PatientRespNoteAddModal = !state.PatientRespNoteAddModal;
        },
        editPatientRespChangeNote:(state, action:PayloadAction<string>) => {
            state.PatientRespChangeNote = action.payload;
        },
        editPatientRespChangeNoteCategory:(state, action:PayloadAction<string>) => {
            state.PatientRespChangeNoteCategory = action.payload;
        },
        toggleDrgGroupMatching:(state) => {
            state.DrgGroupMatching = !state.DrgGroupMatching;
        },
        toggleOutPatientLCodeMatching:(state) => {
            state.OutPatientLCodeMatchingModal = !state.OutPatientLCodeMatchingModal;
        },
        toggleHumanaReferralWarningDialog:(state) => {
            state.HumanaReferralWarningDialog = !state.HumanaReferralWarningDialog;
        },
        toggleBcbsT2GWarningDialog:(state) => {
            state.BcbsT2GWarningDialog = !state.BcbsT2GWarningDialog;
        },
        setBcbsT2GWarningDialog:(state, action:PayloadAction<boolean>) => {
            state.BcbsT2GWarningDialog = action.payload;
        },
        toggleProcedureCodeSetMatching:(state) => {
            state.ProcedureCodeSetMatchingModal = !state.ProcedureCodeSetMatchingModal;
        },
        togglePreQuoteCreateDialog:(state) => {
            state.PreQuoteCreateDialog = !state.PreQuoteCreateDialog;
        },
        togglePreQuoteEditDialog:(state) => {
            state.PreQuoteEditDialog = !state.PreQuoteEditDialog;
        }
    }
})

export const {toggleDetailTab, toggleCodeLookup, toggleInsuranceDetail, toggleVerifyLookupModal, toggleNoteAddModal, toggleEscalatedNoteAddModal, toggleEscalatedNoteResolutionModal, 
    toggleVobRequestNoteAddModal, toggleVobRequestNoteResolutionModal, toggleCallAddModal, toggleWaystarModal,
    toggleCallViewModal, toggleVerifyDocumentDialog, togglePatientRespNoteAddModal, toggleDrgGroupMatching, toggleOutPatientLCodeMatching,
    editPatientRespChangeNote, editPatientRespChangeNoteCategory, toggleHumanaReferralWarningDialog, toggleBcbsT2GWarningDialog, setBcbsT2GWarningDialog, toggleProcedureCodeSetMatching, togglePreQuoteCreateDialog, togglePreQuoteEditDialog}
     = VerificationModuleSlice.actions;
export default VerificationModuleSlice.reducer;